import OrderStop from './OrderStop.styled';

export default OrderStop;
